import { adjustColorForContrast } from '../shared/helpers/colorHelper.js';

export const setPortalHoverColor = theme => {
  // This function is to set the hover color for the portal
  const portalColor = window.portalConfig.portalColor;
  const bgColor = theme === 'dark' ? '#151718' : 'white';
  const hoverColor = adjustColorForContrast(portalColor, bgColor);

  // Set hover color for border and text dynamically
  document.documentElement.style.setProperty(
    '--dynamic-hover-color',
    hoverColor
  );
};

export const removeQueryParamsFromUrl = (queryParam = 'theme') => {
  // This function is to remove the theme query param from the URL
  // This is done so that the theme is not persisted in the URL
  // This is called when the theme is switched from the dropdown
  const url = new URL(window.location.href);
  const param = url.searchParams.get(queryParam);

  if (param) {
    url.searchParams.delete(queryParam);
    window.history.replaceState({}, '', url.toString()); // Convert URL to string
  }
};

export const updateThemeInHeader = theme => {
  const themeToggleButton = document.getElementById('toggle-appearance');
  if (!themeToggleButton) return;

  const allThemeButtons = themeToggleButton.querySelectorAll('.theme-button');
  if (!allThemeButtons.length) return;

  allThemeButtons.forEach(button => {
    const isActive = button.dataset.theme === theme;
    button.classList.toggle('hidden', !isActive);
    button.classList.toggle('block', isActive);
  });
};

export const switchTheme = theme => {
  localStorage.theme = theme;

  document.documentElement.classList.remove('dark', 'light');
  document.documentElement.classList.add(theme);

  setPortalHoverColor(theme);
  updateThemeInHeader(theme);
  removeQueryParamsFromUrl();

  const mobileMenu = document.getElementById('mobile-appearance-dropdown');
  if (mobileMenu) {
    mobileMenu.dataset.currentTheme = theme;
  }
};

export const toggleTheme = () => {
  const currentTheme = localStorage.theme || 'light';
  const newTheme = currentTheme === 'light' ? 'dark' : 'light';
  switchTheme(newTheme);
};

export const initializeThemeHandlers = () => {
  const toggle = document.getElementById('toggle-appearance');
  if (toggle) {
    toggle.addEventListener('click', e => {
      e.stopPropagation();
      toggleTheme();
    });
  }

  document.addEventListener('click', ({ target }) => {
    const themeBtn = target.closest('.mobile-theme-button[data-theme]');
    if (themeBtn) {
      switchTheme(themeBtn.dataset.theme);

      setTimeout(() => {
        const mobileToggle = document.getElementById('mobile-menu-toggle');
        if (mobileToggle) mobileToggle.checked = false;
      }, 300);
    }
  });
};

export const getSystemTheme = () => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};

export const initializeTheme = () => {
  if (window.portalConfig.isPlainLayoutEnabled === 'true') return;
  const initialTheme = localStorage.theme || getSystemTheme();
  switchTheme(initialTheme);

  window.updateThemeInHeader = updateThemeInHeader;

  initializeThemeHandlers();
};
